export default __webpack_public_path__ + "static/poolman-e90c234012e5c09067a8d2ca44307df6.jpg";